import { useSyncExternalStore } from "react"
import { massOpsRunner } from "./massOpsRunnerBridge"

/** Подписка на состояние массовых операций (очередь живёт вне React). */
export const useMassOpsRunner = () =>
  useSyncExternalStore(massOpsRunner.subscribe, massOpsRunner.getSnapshot)
